module.exports = "/_next/static/images/mandiri_ic-af7da46700b5b570cbfa9f6b464e32a7.svg";